import { CircleAlert, TriangleAlert } from 'lucide-react'
import { Meter } from '../../platform/primitives/Meter'
import { envelopeSkin, meterSkin, shownPct } from './budgetRules'
import type { Envelope } from './budgetWire'
import './budget.css'

/**
 * One envelope as a vertical column: the percentage above, the bar between, the
 * name below. The Overview's Budget widget draws a row of these. Same contract as
 * `EnvelopeBar`: the height is the SERVER's percentage clamped to the well, the
 * meter's value is not clamped, and over / close are said in the meter's
 * `aria-valuetext` and in a sign beside the figure, never in colour alone (rule 11).
 *
 * **Callers filter out paused envelopes**, as for `EnvelopeBar`.
 */
export function EnvelopeColumn({ envelope }: { envelope: Envelope }) {
  const now = shownPct(envelope)
  const state = envelopeSkin(envelope)
  const over = state === 'over'
  const close = state === 'close'
  const text = `${now}% used${over ? ', over budget' : close ? ', close to limit' : ''}`
  return (
    <span className="env-col">
      <span className={over ? 'env-col__pct env-col__pct--over' : 'env-col__pct'}>
        {over && <TriangleAlert size={11} aria-hidden />}
        {close && <CircleAlert size={11} aria-hidden />}
        {`${now}%`}
      </span>
      <Meter
        orientation="column"
        label={`${envelope.name} allowance used`}
        value={now}
        fill={envelope.progress.percentage}
        skin={meterSkin(state)}
        valueText={text}
      />
      <span className="env-col__name">{envelope.name}</span>
    </span>
  )
}
